import React from 'react';

import Link from 'src/components/Common/Link';
import Picture from 'src/components/Common/Picture';
import Headline from 'src/components/CE/Headline';
import Avatar from 'src/components/CE/Avatar';
import classNames from 'classnames';

interface BlogItemProps {
  /** Author of the BlogItem. */
  author: string;
  /** classNames to style component. */
  className?: string;
  /** Font color of the BlogItem. */
  color?: string;
  /** Date the BlogItem was posted. (or changed?) */
  date: string;
  /** Path to the image of the BlogItem. */
  imgPath?: string;
  /** Link the BlogItem to where ever you want! */
  link?: string;
  /** Title of the BlogItem. */
  title: string;
}

/** Displays a BlogItem with at least author, date and title. */
const BlogItem = ({
  author,
  className,
  color,
  date,
  imgPath,
  link,
  title,
}: BlogItemProps) => {
  return (
    <Link
      className={classNames(className, `ce-blog-item ${color}`)}
      title={title}
      to={link}
    >
      <div>
        <div className="blog-item-header">
          {author && <Avatar name={author} withName />}
        </div>
        {imgPath && <Picture src={imgPath} alt="Bild Blogartikel" />}
        <div className="blog-footer">
          <Headline>{title}</Headline>
          <div className="date">{date}</div>
        </div>
      </div>
    </Link>
  );
};

BlogItem.defaultProps = {
  className: null,
  color: 'magenta',
  imgPath: null,
  link: null,
};

export default BlogItem;
